import { ASTRA_CHAT_TEST_IDS } from '@amzn/gravion-ui-contracts';
import { FEATURE_FLAGS, getFeatureFlagsForStage } from 'src/context/FeatureFlagsContext';

/** Display name interpolated into the shared panel's copy ("Message Astra", greeting, …). */
export const ASTRA_AGENT_NAME = 'Astra';

/** Amazon AI Policy link shown in the composer disclaimer. */
export const ASTRA_AI_POLICY_URL = 'https://policy.a2z.com/docs/643450/publication';

/** Root test id for the mobile chat page's panel (shared with Playwright via the contracts package). */
export const ASTRA_CHAT_PAGE_TEST_ID = ASTRA_CHAT_TEST_IDS.mobilePage;

/**
 * Whether the mobile "Chat with Astra" surface is on for this stage.
 *
 * Read directly from the stage table rather than the flag context: the v2
 * shell mounts no `FeatureFlagProvider`, and the context hooks silently fall
 * back to all-false defaults without one (same approach as
 * `ProfilePreferencesPage`'s Slack flag). The value is static per build, so
 * callers can read it at module scope or render time alike.
 */
export function isMobileAstraEnabled(): boolean {
  return getFeatureFlagsForStage()[FEATURE_FLAGS.enableMobileAstra];
}
